// Poll only while visible, refresh on return, and coalesce concurrent triggers.
export function startVisiblePolling(refresh, { intervalMs = 60000, events = [] } = {}) {
  let active = true;
  let inFlight = false;
  let lastStarted = -Infinity;
  const controller = new AbortController();
  const run = async () => {
    if (!active || inFlight || document.visibilityState !== "visible") return;
    inFlight = true;
    lastStarted = Date.now();
    try {
      await refresh(controller.signal);
    } catch {
      // Callers handle/report their request failures. Keep polling on failure.
    } finally {
      inFlight = false;
    }
  };
  void run();
  const timer = window.setInterval(run, intervalMs);
  // Browsers often emit visibilitychange followed by focus for one return.
  const onReturn = () => { if (Date.now() - lastStarted >= 1000) void run(); };
  document.addEventListener("visibilitychange", onReturn);
  events.forEach((event) => window.addEventListener(event, event === 'focus' ? onReturn : run));
  return () => {
    active = false;
    controller.abort();
    window.clearInterval(timer);
    document.removeEventListener("visibilitychange", onReturn);
    events.forEach((event) => window.removeEventListener(event, event === 'focus' ? onReturn : run));
  };
}
